import BlueShadeLayout from './BlueShadeLayout'

export default BlueShadeLayout
